import { DEFAULT_DRUID_FILTERS_LIST } from './defaultDruidDimensions';
import { QUICK_LINKS_DIMENSIONS_BLACK_LIST } from './quickLinksDimensionsBlacklist';

export const QUICK_LINKS_DIMENSIONS_WHITE_LIST = [
  ...DEFAULT_DRUID_FILTERS_LIST.filter((dimension) => !QUICK_LINKS_DIMENSIONS_BLACK_LIST.includes(dimension)),
] as const;
